import { QRCodeSVG } from 'qrcode.react';

const QrCode = (props) => {
  const value = `${window.location.origin}/files/${props.id}`;

  return (
    <div style={{ textAlign: 'center' }}>
      <QRCodeSVG
        value={value}
        size={292}
        level="M"
        bgColor="#ffffff"
        fgColor="#000000"
      />
    </div>
  );
};

export default QrCode;